<template>
  <v-row>
    <v-col>
      <expandable-group
        v-for="category in sanitizedProductDescription"
        :key="category.contentCategory"
        :title="category.contentCategory"
        :arialabel-expand="$t('expandDescription', [category.contentCategory])"
        :arialabel-collapse="$t('collapseDescription', [category.contentCategory])"
      >
        <div class="my-1 mx-2 text-justify content text-body-2" v-html="category.sanitizedValue" />
      </expandable-group>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import ExpandableGroup from '@/components/ExpandableGroup.vue'
import { ProductDescription } from '@/modules/product/types'
import DOMPurify from 'dompurify'
import { computed, PropType } from 'vue'

const props = defineProps({
  productDescription: {
    type: Array as PropType<ProductDescription[]>,
    required: true
  }
})

const sanitizedProductDescription = computed(() =>
  props.productDescription.map((desc) => ({
    ...desc,
    sanitizedValue: DOMPurify.sanitize(desc.value)
  }))
)
</script>

<style scoped>
.content :deep(img) {
  max-width: 100%;
}

.content :deep(ul) {
  padding-left: 20px;
  margin: 8px 0;
}
</style>
